export default __webpack_public_path__ + "static/media/milestone 4800.a7312773.svg";